import * as Sentry from '@sentry/vue';
import { useAuthStore } from '@/stores/auth';
import { apiErrorContext } from '@/utils/apiError';

const errorTimestamps = new Map();

const buildSignature = (message = '', stack = '') => `${message}::${stack}`;

export default {
  install(app, { router } = {}) {
    const toast = () => app.config.globalProperties.$toast;

    const logError = (error, context = '', options = 5000) => {
      try {
        const { throttleMs = 5000, notify = true } = typeof options === 'number'
          ? { throttleMs: options }
          : options || {};
        const message = error?.message || String(error);
        const stack = error instanceof Error ? error.stack || '' : '';
        const finalMessage = context ? `[${context}] ${message}` : message;

        if ([401, 403].includes(error?.response?.status)) {
          toast()?.error?.('Session expired, please sign in again.');
          const authStore = useAuthStore();
          authStore.logout();
          router?.push?.({ name: 'auth' });
          return;
        }

        const api = apiErrorContext(error);
        const signature = buildSignature(`${finalMessage}::${JSON.stringify(api)}`, stack);
        const now = Date.now();
        const lastLogged = errorTimestamps.get(signature) || 0;
        if (lastLogged + throttleMs > now) {
          return;
        }
        errorTimestamps.set(signature, now);

        console.error(finalMessage, error);
        Sentry.captureException(error instanceof Error ? error : new Error(finalMessage), {
          tags: { context },
          ...(api ? { contexts: { api } } : {}),
        });

        if (context && notify) {
          toast()?.error?.(finalMessage);
        }
      } catch (loggingError) {
        console.error('Failed to log error', loggingError);
        Sentry.captureException(loggingError);
      }
    };

    app.config.globalProperties.$logError = logError;
  },
};
